import { useNavigate } from '@tanstack/react-router';
import { IconButton } from '#core/components';
import { XIcon } from '#core/components/icons';
import { useCombobox } from '../../combobox';
import { useCurrentEditor } from '../hooks';

export const ClearButton = () => {
  const navigate = useNavigate();
  const { state } = useCombobox();
  const { editor } = useCurrentEditor();

  const handlePress = () => {
    state.close();
    editor?.commands.clearContent();
    navigate({ to: '/search', search: {} });
  };

  if (editor?.isEmpty) return null;

  return (
    <IconButton h={8} onPress={handlePress} w={8}>
      <XIcon />
    </IconButton>
  );
};
